import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 24, once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-8% 0px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", delay = 0, gap = 0.09 }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8% 0px" }}
    variants={{ show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", y = 22 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal — the signature hero moment.
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((ln, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]" aria-hidden="true">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.13 }}
        >
          {ln}
        </motion.span>
      </span>
    ))}
  </span>
);
